@let color = mobileMenuOpen || !transparent ? 'black' : 'white';
@let logoAlt = 'Kinomap ' + color + ' logo';
@let activeRoute = activeRoute$ | async;

<!-- Navigation Desktop & Tablette -->
@if (!(isMobile$ | async)) {
  <nav id="navbar" [ngClass]="{ 'not-transparent': !transparent, hide }">
    <div class="left">
      <div class="brand-logo" (click)="navigateTo('home')">
        <img
          class="big-logo"
          [src]="'assets/images/logo/kinomap_primary_' + color + '.png'"
          [alt]="logoAlt" />
        <img
          class="small-logo"
          [src]="'assets/images/logo/logo_only_' + color + '.png'"
          [alt]="logoAlt" />
      </div>
      <div
        class="search-content"
        [ngClass]="{ 'smaller-screen': (isBigScreen$ | async) !== true }">
        <a
          [routerLink]="['/', searchContentLink]"
          [routerLinkActive]="['active']"
          (click)="navigateTo(searchContentLink, true)"
          [ngClass]="{
            active: (activeRoute$ | async).startsWith('/' + searchContentLink),
          }">
          <span class="icon icon-search"></span>
          <div class="search-text">
            <span class="search-text-1">
              {{ 'header.search' | translate }}
            </span>
            <span class="search-text-2">
              {{ 'header.forContent' | translate }}</span
            >
          </div>
        </a>
      </div>
    </div>

    <div class="center">
      <a
        [routerLink]="['/home']"
        (click)="$event.preventDefault(); navigateTo('home', true)"
        [ngClass]="{ active: activeRoute === '/home' }">
        {{ 'header.home' | translate }}
      </a>
      @for (item of menu.secondary; track $index) {
        @if (item.subMenu?.length > 0) {
          <div
            ngbDropdown
            display="dynamic"
            placement="bottom-left"
            class="menu-dropdown">
            <a
              ngbDropdownToggle
              role="button"
              class="menu-link"
              [ngClass]="{ active: isActiveRoute(activeRoute, item) }"
              (click)="$event.preventDefault()">
              {{ item.name | translate }}
              <span class="chevron"></span>
            </a>

            <div
              class="btn-dropdown"
              ngbDropdownMenu
              aria-labelledby="subMenuDropdown">
              @for (sub of item.subMenu; track $index) {
                <a
                  style="text-align: left"
                  ngbDropdownItem
                  (click)="
                    $event.preventDefault();
                    navigateTo(sub.link, sub.internal, sub.scrollTo)
                  "
                  [ngClass]="{ active: isActiveRoute(activeRoute, sub) }">
                  <span>{{ sub.name | translate }}</span>
                </a>
              }
            </div>
          </div>
        } @else {
          <a
            [routerLink]="['/', item.link]"
            [fragment]="item.scrollTo"
            (click)="
              $event.preventDefault();
              navigateTo(item.link, item.internal, item.scrollTo)
            "
            [ngClass]="{ active: isActiveRoute(activeRoute, item) }"
            class="menu-link">
            {{ item.name | translate }}
          </a>
        }
      }
    </div>

    <div class="right">
      @if (loading$ | async) {
        <div class="skeleton-container">
          <kin-skeleton
            [width]="2"
            [height]="2"
            [bgColor]="transparent ? '' : '#f4f4f4'" />
          <kin-skeleton
            class="username"
            [width]="4"
            [height]="1"
            [bgColor]="transparent ? '' : '#f4f4f4'" />
        </div>
      } @else if (!user) {
        <kin-btn (onClick)="loginService.redirectToOauth()" color="primary">
          {{ 'header.login' | translate }}
        </kin-btn>
      } @else {
        <ng-container *ngTemplateOutlet="userBtn" />
      }

      <!-- Languages -->
      <div ngbDropdown display="dynamic" placement="bottom-right">
        <button ngbDropdownToggle role="button" class="language-btn">
          <img
            src="./assets/images/flags/{{ currentLanguage }}.svg"
            [alt]="currentLanguage + ' flag'" />
          <span>&nbsp;{{ getLanguage(currentLanguage) }}</span>
        </button>

        <div
          class="btn-dropdown"
          ngbDropdownMenu
          aria-labelledby="languagesDropdown">
          @for (lang of allAvailableLanguages; track $index) {
            <ng-container>
              @if (lang !== currentLanguage) {
                <a
                  (click)="$event.preventDefault(); switchLang(lang)"
                  ngbDropdownItem>
                  <img
                    height="22"
                    src="./assets/images/flags/{{ lang }}.svg"
                    [alt]="getLanguage(lang) + ' flag'" />
                  <span>&nbsp;{{ getLanguage(lang) }} </span>
                </a>
              }
            </ng-container>
          }
        </div>
      </div>
    </div>
  </nav>
}

<!-- Navigation Mobile -->
@if (isMobile$ | async) {
  <nav id="navbarMobile" [ngClass]="{ 'not-transparent': !transparent, hide }">
    <div
      id="burgerMenu"
      [ngClass]="{ active: mobileMenuOpen }"
      (click)="closeMobileMenu()">
      <span class="filet">&nbsp;</span>
      <span class="filet">&nbsp;</span>
      <span class="filet">&nbsp;</span>
    </div>

    @if (mobileMenuOpen) {
      <div @menuSlide id="mobMenu">
        <div class="search-content">
          <a
            [routerLink]="['/', searchContentLink]"
            (click)="navigateTo(searchContentLink, true)"
            [ngClass]="{
              active: (activeRoute$ | async).startsWith(
                '/' + searchContentLink
              ),
            }">
            <span class="icon icon-search"></span>
            <span>
              {{ 'header.search' | translate
              }}{{ 'header.forContent' | translate }}
            </span>
          </a>
        </div>
        <div class="link-list">
          <a
            [routerLink]="['/home']"
            (click)="navigateTo('home')"
            [ngClass]="{ active: (activeRoute$ | async) === 'home' }">
            {{ 'header.home' | translate }}
          </a>
          @for (item of menu.secondary; track $index) {
            @if (item.subMenu?.length > 0) {
              <div
                ngbDropdown
                display="dynamic"
                placement="bottom-left"
                class="menu-dropdown">
                <a
                  ngbDropdownToggle
                  role="button"
                  class="menu-link"
                  [ngClass]="{ active: isActiveRoute(activeRoute, item) }"
                  (click)="$event.preventDefault()">
                  {{ item.name | translate }}
                  <span class="chevron"></span>
                </a>

                <div
                  class="btn-dropdown"
                  ngbDropdownMenu
                  aria-labelledby="subMenuDropdown">
                  @for (sub of item.subMenu; track $index) {
                    <a
                      style="text-align: left"
                      ngbDropdownItem
                      (click)="
                        $event.preventDefault();
                        navigateTo(sub.link, sub.internal, sub.scrollTo)
                      "
                      [ngClass]="{ active: isActiveRoute(activeRoute, sub) }">
                      <span>{{ sub.name | translate }}</span>
                    </a>
                  }
                </div>
              </div>
            } @else {
              <a
                [routerLink]="['/', item.link]"
                [fragment]="item.scrollTo"
                (click)="
                  $event.preventDefault();
                  navigateTo(item.link, item.internal, item.scrollTo)
                "
                [ngClass]="{ active: isActiveRoute(activeRoute, item) }"
                class="menu-link">
                {{ item.name | translate }}
              </a>
            }
          }
          @if (loading$ | async) {
            <div class="user-btn skeleton-container">
              <kin-skeleton [width]="2" [height]="2" />
            </div>
          } @else if (!user) {
            <kin-btn
              class="login-btn"
              color="primary"
              size="large"
              (onClick)="loginService.redirectToOauth()">
              {{ 'header.login' | translate }}
            </kin-btn>
          } @else {
            <ng-container *ngTemplateOutlet="userBtn" />
          }
        </div>
      </div>
    }

    <div class="brand-logo" (click)="navigateTo('home')">
      <img
        [src]="'assets/images/logo/kinomap_primary_' + color + '.png'"
        [alt]="logoAlt" />
    </div>

    <!-- Languages -->
    <div
      ngbDropdown
      display="dynamic"
      placement="bottom-right"
      [ngClass]="{
        'display-none': (windowSize$ | async) < 300,
      }">
      <button ngbDropdownToggle role="button" class="language-btn">
        <img
          height="22"
          src="./assets/images/flags/{{ currentLanguage }}.svg"
          [alt]="getLanguage(currentLanguage) + ' flag'" />
        <span [ngClass]="{ 'black-font': mobileMenuOpen }"
          >&nbsp;{{ getLanguage(currentLanguage) }}</span
        >
      </button>

      <div
        id="langList"
        class="btn-dropdown"
        ngbDropdownMenu
        aria-labelledby="languagesDropdown">
        @for (lang of allAvailableLanguages; track $index) {
          <ng-container>
            @if (lang !== currentLanguage) {
              <a
                [routerLink]="['']"
                [queryParams]="{ lang: lang }"
                (click)="$event.preventDefault(); switchLang(lang)"
                ngbDropdownItem>
                <img
                  height="22"
                  src="./assets/images/flags/{{ lang }}.svg"
                  [alt]="getLanguage(lang) + ' flag'" />
                <span>&nbsp;{{ getLanguage(lang) }} </span>
              </a>
            }
          </ng-container>
        }
      </div>
    </div>
  </nav>
}

<ng-template #userBtn>
  <div
    ngbDropdown
    display="dynamic"
    [placement]="(isMobile$ | async) ? 'top' : 'bottom'">
    <button ngbDropdownToggle role="button" class="user-btn">
      <img [src]="user?.avatar_url" [alt]="user?.username + 'user avatar'" />
      <span class="username">&nbsp;{{ user?.username }}</span>
    </button>

    <div ngbDropdownMenu aria-labelledby="userDropdown" class="btn-dropdown">
      @for (item of userMenu; track $index) {
        <div>
          <ng-container>
            @switch (item.type) {
              @case ('hr') {
                <hr />
              }
              @case ('external-link') {
                <a [routerLink]="[item.link]" ngbDropdownItem>{{
                  item.name | translate
                }}</a>
              }
              @case ('internal-link') {
                <a [routerLink]="[item.route]" ngbDropdownItem>{{
                  item.name | translate
                }}</a>
              }
            }
          </ng-container>
        </div>
      }
      @if (user?.is_admin) {
        <div>
          <hr />
          <a [href]="[adminSiteLink]" target="_blank" ngbDropdownItem>{{
            'menu.profil.admin' | translate
          }}</a>
          <a [href]="[adminv2SiteLink]" target="_blank" ngbDropdownItem>{{
            'menu.profil.adminv2' | translate
          }}</a>
        </div>
      }
      <hr />
      <a [routerLink]="['/home']" (click)="disconnect()" ngbDropdownItem>{{
        'menu.profil.logout' | translate
      }}</a>
    </div>
  </div>
</ng-template>
